export var getBasketUrl = function (basketCustomObjectKey) {
    var protocol = location.protocol, host = location.host;
    return "".concat(protocol, "//").concat(host, "/?").concat("basketId" /* BasketUrlParameter.BasketId */, "=").concat(basketCustomObjectKey);
};
